import script from "./BlogsBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogsBlock.vue?vue&type=script&setup=true&lang=ts"

import "./BlogsBlock.vue?vue&type=style&index=0&id=219a53b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-219a53b0"]])

export default __exports__